import { render, staticRenderFns } from "./IconKKMRegistered.vue?vue&type=template&id=c53f6d1e&"
import script from "./IconKKMRegistered.vue?vue&type=script&lang=js&"
export * from "./IconKKMRegistered.vue?vue&type=script&lang=js&"
import style0 from "./IconKKMRegistered.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports